<template>
    <svg
        width="660"
        height="495"
        viewBox="0 0 660 495"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 166.5C0 159.873 5.37258 154.5 12 154.5H198C204.627 154.5 210 159.873 210 166.5V407.5C210 414.127 204.627 419.5 198 419.5H12C5.37258 419.5 0 414.127 0 407.5V166.5Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M450 165C450 158.373 455.373 153 462 153H648C654.627 153 660 158.373 660 165V409C660 415.627 654.627 421 648 421H462C455.373 421 450 415.627 450 409V165Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M443.221 133.5H216.777C210.426 133.5 205.277 138.649 205.277 145V422.333C205.277 428.684 210.426 433.833 216.777 433.833H443.221C449.572 433.833 454.721 428.684 454.721 422.333V145C454.721 138.649 449.572 133.5 443.221 133.5Z"
            fill="var(--et-colors-card-background)"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="36"
            font-weight="600"
            letter-spacing="-0.01em"
        >
            <tspan x="272.338" y="58.2">Pricing</tspan>
        </text>
        <text
            fill="#475467"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16"
            letter-spacing="0em"
        >
            <tspan x="228.398" y="90.2">Choose best option for you.</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="16" y="181.9">Base</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="16" y="212.3">$29</tspan>
        </text>
        <path
            d="M29.3337 303.5L22.0003 310.833L18.667 307.5"
            stroke="#079455"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M27.3337 324.167L20.667 330.834M20.667 324.167L27.3337 330.834"
            stroke="#D92D20"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M27.3337 344.167L20.667 350.834M20.667 344.167L27.3337 350.834"
            stroke="#D92D20"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M24 372H186C190.142 372 193.5 375.358 193.5 379.5V395.5C193.5 399.642 190.142 403 186 403H24C19.8579 403 16.5 399.642 16.5 395.5V379.5C16.5 375.358 19.8579 372 24 372Z"
            stroke="var(--et-colors-border)"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="466" y="180.4">Premium</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="466" y="213.8">$69</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="521" y="209.9">$79</tspan>
        </text>
        <path
            d="M479.334 305L472 312.333L468.667 309"
            stroke="#079455"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M479.334 325L472 332.333L468.667 329"
            stroke="#079455"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M479.334 345L472 352.333L468.667 349"
            stroke="#079455"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M24 372H186C190.142 372 193.5 375.358 193.5 379.5V395.5C193.5 399.642 190.142 403 186 403H24C19.8579 403 16.5 399.642 16.5 395.5V379.5C16.5 375.358 19.8579 372 24 372Z"
            fill="none"
        />
        <path
            d="M474 373.5H636C640.142 373.5 643.5 376.858 643.5 381V397C643.5 401.142 640.142 404.5 636 404.5H474C469.858 404.5 466.5 401.142 466.5 397V381C466.5 376.858 469.858 373.5 474 373.5Z"
            fill="none"
        />
        <path
            d="M474 373.5H636C640.142 373.5 643.5 376.858 643.5 381V397C643.5 401.142 640.142 404.5 636 404.5H474C469.858 404.5 466.5 401.142 466.5 397V381C466.5 376.858 469.858 373.5 474 373.5Z"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M443.221 133.5H216.777C210.426 133.5 205.277 138.649 205.277 145V422.333C205.277 428.684 210.426 433.833 216.777 433.833H443.221C449.573 433.833 454.721 428.684 454.721 422.333V145C454.721 138.649 449.573 133.5 443.221 133.5Z"
            stroke="var(--et-colors-brand)"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="220.777" y="161.8">Standard</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="28"
            letter-spacing="0em"
        >
            <tspan x="220.777" y="197.267">$49</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="285.11" y="192.467">$59</tspan>
        </text>
        <path
            d="M236.334 302.333L227.779 310.888L223.89 306.999"
            stroke="#079455"
            stroke-width="1.16667"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M236.334 325L227.779 333.556L223.89 329.667"
            stroke="#079455"
            stroke-width="1.16667"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M234 348.445L226.223 356.223M226.223 348.445L234 356.223"
            stroke="#D92D20"
            stroke-width="1.16667"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M188 235.5H22C18.6863 235.5 16 238.186 16 241.5C16 244.814 18.6863 247.5 22 247.5H188C191.314 247.5 194 244.814 194 241.5C194 238.186 191.314 235.5 188 235.5Z"
            fill="#F2F4F7"
        />
        <path
            d="M132 255.5H22C18.6863 255.5 16 258.186 16 261.5C16 264.814 18.6863 267.5 22 267.5H132C135.314 267.5 138 264.814 138 261.5C138 258.186 135.314 255.5 132 255.5Z"
            fill="#F2F4F7"
        />
        <path
            d="M166 301.5H42C38.6863 301.5 36 304.186 36 307.5C36 310.814 38.6863 313.5 42 313.5H166C169.314 313.5 172 310.814 172 307.5C172 304.186 169.314 301.5 166 301.5Z"
            fill="#F2F4F7"
        />
        <path
            d="M114 321.5H42C38.6863 321.5 36 324.186 36 327.5C36 330.814 38.6863 333.5 42 333.5H114C117.314 333.5 120 330.814 120 327.5C120 324.186 117.314 321.5 114 321.5Z"
            fill="#F2F4F7"
        />
        <path
            d="M139 341.5H42C38.6863 341.5 36 344.186 36 347.5C36 350.814 38.6863 353.5 42 353.5H139C142.314 353.5 145 350.814 145 347.5C145 344.186 142.314 341.5 139 341.5Z"
            fill="#F2F4F7"
        />
        <path
            d="M621 237H472C468.686 237 466 239.686 466 243C466 246.314 468.686 249 472 249H621C624.314 249 627 246.314 627 243C627 239.686 624.314 237 621 237Z"
            fill="#F2F4F7"
        />
        <path
            d="M535 257H472C468.686 257 466 259.686 466 263C466 266.314 468.686 269 472 269H535C538.314 269 541 266.314 541 263C541 259.686 538.314 257 535 257Z"
            fill="#F2F4F7"
        />
        <path
            d="M616 303H492C488.686 303 486 305.686 486 309C486 312.314 488.686 315 492 315H616C619.314 315 622 312.314 622 309C622 305.686 619.314 303 616 303Z"
            fill="#F2F4F7"
        />
        <path
            d="M564 323H492C488.686 323 486 325.686 486 329C486 332.314 488.686 335 492 335H564C567.314 335 570 332.314 570 329C570 325.686 567.314 323 564 323Z"
            fill="#F2F4F7"
        />
        <path
            d="M589 343H492C488.686 343 486 345.686 486 349C486 352.314 488.686 355 492 355H589C592.314 355 595 352.314 595 349C595 345.686 592.314 343 589 343Z"
            fill="#F2F4F7"
        />
        <path
            d="M432.221 224.333H227.777C223.911 224.333 220.777 227.467 220.777 231.333C220.777 235.199 223.911 238.333 227.777 238.333H432.221C436.087 238.333 439.221 235.199 439.221 231.333C439.221 227.467 436.087 224.333 432.221 224.333Z"
            fill="#F2F4F7"
        />
        <path
            d="M391.11 246.333H227.777C223.911 246.333 220.777 249.467 220.777 253.333C220.777 257.199 223.911 260.333 227.777 260.333H391.11C394.976 260.333 398.11 257.199 398.11 253.333C398.11 249.467 394.976 246.333 391.11 246.333Z"
            fill="#F2F4F7"
        />
        <path
            d="M395.777 300H251.11C247.244 300 244.11 303.134 244.11 307C244.11 310.866 247.244 314 251.11 314H395.777C399.643 314 402.777 310.866 402.777 307C402.777 303.134 399.643 300 395.777 300Z"
            fill="#F2F4F7"
        />
        <path
            d="M335.11 322.667H251.11C247.244 322.667 244.11 325.801 244.11 329.667C244.11 333.533 247.244 336.667 251.11 336.667H335.11C338.976 336.667 342.11 333.533 342.11 329.667C342.11 325.801 338.976 322.667 335.11 322.667Z"
            fill="#F2F4F7"
        />
        <path
            d="M364.277 345.333H251.11C247.244 345.333 244.11 348.467 244.11 352.333C244.11 356.199 247.244 359.333 251.11 359.333H364.277C368.143 359.333 371.277 356.199 371.277 352.333C371.277 348.467 368.143 345.333 364.277 345.333Z"
            fill="#F2F4F7"
        />
        <path
            d="M431.221 380.833H228.777C224.635 380.833 221.277 384.191 221.277 388.333V410.333C221.277 414.475 224.635 417.833 228.777 417.833H431.221C435.363 417.833 438.721 414.475 438.721 410.333V388.333C438.721 384.191 435.363 380.833 431.221 380.833Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M431.221 380.833H228.777C224.635 380.833 221.277 384.191 221.277 388.333V410.333C221.277 414.475 224.635 417.833 228.777 417.833H431.221C435.363 417.833 438.721 414.475 438.721 410.333V388.333C438.721 384.191 435.363 380.833 431.221 380.833Z"
            stroke="var(--et-colors-border)"
        />
        <text
            fill="var(--et-colors-card-background)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16.3333"
            letter-spacing="0em"
        >
            <tspan x="300.499" y="404.1">Choose</tspan>
        </text>
        <path
            d="M360.861 119.583H297.194C289.6 119.583 283.444 125.739 283.444 133.333C283.444 140.927 289.6 147.083 297.194 147.083H360.861C368.455 147.083 374.611 140.927 374.611 133.333C374.611 125.739 368.455 119.583 360.861 119.583Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M360.861 119.583H297.194C289.6 119.583 283.444 125.739 283.444 133.333C283.444 140.927 289.6 147.083 297.194 147.083H360.861C368.455 147.083 374.611 140.927 374.611 133.333C374.611 125.739 368.455 119.583 360.861 119.583Z"
            stroke="var(--et-colors-border)"
            stroke-width="1.16667"
        />
        <text
            fill="var(--et-colors-card-background)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="294.957" y="137.3">Bestseller</tspan>
        </text>
    </svg>
</template>
